module.exports = "/_next/static/images/videoInstruction-1fc9eeac3489061d7af0622ff1e28150.jpg.webp";